import React, { useEffect, useState } from "react";
import { Popup } from "devextreme-react/popup";
import httpService from "../../services/http-service";
import { getAuthToken } from "../../services/auth-service";
import { Toster } from "../../components/Toster/Toster";
import { logOut } from "../../components/Logout";
import { useNavigate } from "react-router-dom";
import './AddGroupPopup.css'
import { ReactComponent as AddGroupIcon } from '../../assets/images/Checkbox-marked-circle-plus-outline.svg.svg'

const AddGroupPopup = ({ visible, onClose, onSuccess, toastConfig, setToastConfig, groupToEdit }) => {
    const [groupName, setGroupName] = useState("");
    const [loading, setLoading] = useState(false);
    const [validationAttempted, setValidationAttempted] = useState(false)
    const navigate = useNavigate();
    const pathURL = window.location.hostname.split(".")[0];

    useEffect(() => {
        if (groupToEdit) {
            setGroupName(groupToEdit["Group Name"] || "");
        } else {
            setGroupName("");
        }
        setValidationAttempted(false);
    }, [groupToEdit, visible]);


    const handleSave = () => {

        setValidationAttempted(true);
        if(!groupName.trim()){
                return;
        }

        setLoading(true);
        const token = getAuthToken();

        const payload = groupToEdit?.gGroupId
            ? {
                groupId: groupToEdit.gGroupId, 
                groupName,
                userId: null,
            }
            : {
                groupName,
                groupId: null,                     
               
            };

        httpService
            .post(
                "api/user-groups/save-group",
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Domain: pathURL,
                    },
                }
            )
            .then(() => {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    message: "Group added successfully",
                    type: "success",
                });
                setTimeout(() => {
                    setToastConfig({ ...toastConfig, isVisible: false });
                }, 1400);
                setGroupName("");
                setValidationAttempted(false);
                onClose();
                onSuccess();
            })
            .catch((val) => {
                setLoading(false);
                if (!val?.response) {
                    navigate(`/error/500`);
                } else if (val?.response?.status === 401) {
                    logOut();
                } else {
                    setToastConfig({
                        ...toastConfig,
                        isVisible: true,
                        message: "Error saving group",
                        type: "error",
                    });
                    setTimeout(() => {
                        setToastConfig({ ...toastConfig, isVisible: false });
                    }, 1500);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            dragEnabled={false}
            showTitle={false}
            width={400}
            height={"auto"}
        >
            <div className="popup_container">
                <div className="popup_header">
                    <div className="popup_icon_box">
                        <AddGroupIcon width={30} height={20} fill="white" />
                    </div>
                    <div className="popup_label_box">Groups</div>
                </div>

                <div className="popup_body">
                    <label className="go-to-label-filed">Group Name <span>*</span></label>
                    <input
                        type="text"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        placeholder="Enter group name"
                        className="input_box"
                    />
                    {
                        validationAttempted && !groupName.trim() && (
                            <p className="error" style={{ color: "red" }}>Please enter group name </p>
                        )
                    }
                </div>
                <div className="popup_footer">
                    <button className="btn dark" onClick={handleSave}>
                        Save
                    </button>
                    <button className="btn light" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default AddGroupPopup;
